export default __webpack_public_path__ + "static/media/flex-play.fb47d779.png";